export default {
    common: {
        home: 'الرئيسية',
        mainMenu: 'القائمة الرئيسية',
        inbox: 'صندوق الوارد',
        requests: 'الطلبات',
        reports: 'التقارير',
        settings: 'الإعدادات',
        accesses: 'الصلاحيات',
        flowAdmin: 'إدارة التدفق',
        states: 'الحالات',
        documents: 'الوثائق',
        reviewers: 'المراجعون',
        close: 'إغلاق',
        save: 'حفظ',
        edit: 'تعديل',
        delete: 'حذف',
        detail: 'تفاصيل',
        actions: 'الإجراءات',
        status: 'الحالة',
        value: 'القيمة',
        area: 'المنطقة',
        creatorUser: 'تم الإنشاء بواسطة',
        search: 'بحث',
        comments: 'التعليقات',
        yes: 'نعم',
        no: 'لا',
        loading: 'جارٍ التحميل...',
        saving: 'جارٍ الحفظ...',
        requiredField: 'هذا الحقل مطلوب',
        requiredOption: 'يرجى اختيار خيار',
        na: 'غير متوفر'
    },
    menu: {
        report1: 'التقرير 1',
        report2: 'التقرير 2',
        dashboardReport: 'تقرير لوحة المعلومات'
    },
    solicitud: {
        title: 'طلب مذكرة اتفاق',
        registerRequest: 'تسجيل الطلب',
        createRequest: 'إنشاء طلب',
        updateRequest: 'تحديث الطلب',
        requestDetail: 'تفاصيل الطلب',
        generalInfo: 'المعلومات العامة',
        processInfo: 'معلومات العملية',
        attachments: 'المرفقات',
        tracking: 'التتبع',
        trackingProcess: 'تتبع العملية',
        trackingList: 'قائمة التتبع',
        registerComment: 'تسجيل تعليق',
        timeline: 'الخط الزمني',
        reviewers: 'المراجعون',
        titleField: 'العنوان',
        project: 'المشروع',
        grant: 'المنحة',
        amount: 'المبلغ',
        object: 'الغرض',
        donor: 'الجهة المانحة',
        responsible: 'المسؤول',
        implementingPartner: 'الشريك المنفذ',
        additionalComments: 'تعليقات إضافية',
        requestDate: 'تاريخ الطلب',
        recordDate: 'تاريخ التسجيل',
        consecutive: 'الرقم المتسلسل',
        creatorArea: 'المنشئ / القسم',
        registerCommentBtn: 'تسجيل تعليق',
        saveDraft: 'حفظ مسودة',
        draftSaved: 'تم حفظ المسودة بنجاح',
        requestSaved: 'تم حفظ الطلب بنجاح',
        commentSaved: 'تم حفظ التعليق بنجاح',
        saveError: 'حدث خطأ أثناء حفظ الطلب.',
        commentSaveError: 'حدث خطأ أثناء حفظ التعليق.',
        deleteConfirmTitle: 'تأكيد الحذف',
        deleteConfirmText: 'هل أنت متأكد أنك تريد حذف هذا السجل؟',
        editTooltip: 'تعديل',
        detailTooltip: 'تفاصيل',
        deleteTooltip: 'حذف',
        approvedRequest: 'طلب معتمد',
        noActionsAvailable: 'لا توجد إجراءات متاحة لهذه الحالة.',
        attachAgreement: 'إرفاق مذكرة الاتفاق',
        observations: 'ملاحظات',
        user: 'المستخدم',
        from: 'من',
        result: 'النتيجة',
        initialState: 'الحالة الأولية',
        finalState: 'الحالة النهائية',
        date: 'التاريخ',
        bp: 'BP',
        unitedId: 'معرف الأمم المتحدة',
        validationDate: 'تاريخ التحقق',
        applicationFrom: 'رقم الطلب',
        agreementNumber: 'رقم الاتفاقية',
        policyAttach: 'إرفاق السياسة',
        receiptAttach: 'إرفاق إيصال الدفع',
        maAttach: 'إرفاق MA',
        fields: {
            searchLabel: 'البحث حسب العنوان و/أو الرقم المتسلسل'
        },
        validations: {
            draftMin: 'لحفظ مسودة يجب إدخال العنوان والمبلغ على الأقل.',
            attachAgreementRequired: 'يجب إرفاق مذكرة الاتفاق.',
            actionObservationRequired: 'يجب إدخال ملاحظات لهذا الإجراء.',
            bpUnitedDateRequired: 'يجب إدخال BP ومعرف الأمم المتحدة وتاريخ التحقق للموافقة.',
            returnObservationRequired: 'يجب إدخال ملاحظات للإرجاع.',
            returnFieldsEmpty: 'للإرجاع يجب أن تكون BP / معرف الأمم المتحدة / تاريخ التحقق فارغة.',
            applicationFromRequired: 'يجب إدخال رقم الطلب.',
            agreementRequired: 'يجب إدخال رقم الاتفاقية.',
            stateApprovedNeedBp: 'يجب إدخال BP عند اعتماد الطلب',
            stateApprovedNeedUnited: 'يجب إدخال معرف الأمم المتحدة عند اعتماد الطلب',
            stateApprovedNeedDate: 'يجب إدخال تاريخ التحقق عند اعتماد الطلب',
            requiredPolicy: 'السياسة مطلوبة',
            requiredReceipt: 'إيصال الدفع مطلوب',
            requiredMA: 'ملف MA مطلوب'
        },
        actions: {
            approve: 'موافقة',
            send: 'إرسال',
            create: 'إنشاء',
            finish: 'إنهاء',
            liquidate: 'تصفية',
            return: 'إرجاع',
            reject: 'رفض',
            cancel: 'إلغاء'
        },
        results: {
            canceled: 'تم الإلغاء',
            request: 'طلب',
            received: 'تم الاستلام',
            comment: 'تعليق',
            finished: 'مكتمل',
            returned: 'تم الإرجاع',
            code: 'الرمز'
        },
        excelHeaders: {
            actions: 'الإجراءات',
            status: 'الحالة',
            consecutive: 'الرقم المتسلسل',
            title: 'العنوان',
            requestDate: 'تاريخ الطلب',
            value: 'المبلغ',
            grant: 'المنحة',
            area: 'المنطقة',
            creatorUser: 'تم الإنشاء بواسطة'
        }
    }
}